import { Text } from "native-base";
import { COMMONFONTSIZE, COMMONFONTWEIGHT } from "../../utils/fonts";

const FormHeader = ({ text = "" }) => {
  return (
    <Text
      fontSize={COMMONFONTSIZE.LARGE_MEDIUM_FONT_SIZE}
      fontWeight={COMMONFONTWEIGHT.MEDIUM_FONT_WEIGHT}
    >
      {text}
    </Text>
  );
};

export default FormHeader;
